// Used as a callback for the Contract document build prcoess to
// refresh the documents table via turbo
window.turboContractsDocumentsTableBody = () => {
  const $wrapper = $('#contracts-document-table-wrapper');
  const turboFrame = $wrapper.find('turbo-frame')[0];
  turboFrame.src = turboFrame.dataset.src;
  turboFrame.reload();
}